import type { SignUpConfig } from '#types/config/components/form/signUp'
import type { RecursivePartial } from '#types/utils'

export default {
  agreementCheckboxes: [
    {
      type: 'termsConditionsAndPolicy',
      locales: [
        'cs-cz',
        'da-dk',
        'de-at',
        'de-ch',
        'de-lu',
        'en-ch',
        'en-dk',
        'en-fi',
        'en-lu',
        'en-se',
        'fr-be',
        'fr-ch',
        'fr-lu',
        'it-ch',
        'nl-be',
        'nl-lu',
        'pl-pl',
        'pt-pt',
        'sv-fi',
        'sv-se'
      ],
      required: true
    },
    {
      type: 'loyaltyTerms',
      locales: ['de-de', 'en-ca', 'es-es', 'en-gb', 'en-ie', 'en-us', 'fr-ca', 'fr-fr', 'it-it', 'nl-nl'],
      required: true,
      showCheckboxInBenefitsSection: ['en-ca', 'en-us', 'fr-ca'],
    },
    {
      type: 'newsletter'
    },
    {
      type: 'policy',
      locales: ['en-ca', 'en-us', 'fr-ca'],
      required: true,
      showCheckboxInBenefitsSection: ['en-ca', 'en-us', 'fr-ca'],
    }
  ],
  gender: {
    options: [
      { value: 'M', label: 'male' },
      { value: 'F', label: 'female' },
      { value: 'NA', label: 'preferNotToAnswer' }
    ],
    requiredLocales: [
      'cs-cz',
      'de-at',
      'de-be',
      'de-ch',
      'de-de',
      'de-lu',
      'en-ch',
      'en-dk',
      'en-fi',
      'en-gb',
      'en-ie',
      'en-se',
      'es-es',
      'fr-be',
      'fr-ch',
      'fr-fr',
      'fr-lu',
      'it-ch',
      'it-it',
      'nl-be',
      'nl-lu',
      'nl-nl',
      'pl-pl',
      'pt-pt',
      'sv-fi',
    ]
  },
  isBirthDateRequired: false,
  isSmsOptInRequired: false,
  loyaltyAgreementCheckboxes: [
    {
      type: 'loyaltyTerms',
      locales: ['de-de', 'en-ca', 'es-es', 'en-gb', 'en-ie', 'en-us', 'fr-ca', 'fr-fr', 'it-it', 'nl-nl'],
      required: true
    },
    {
      type: 'policy',
      locales: ['en-ca', 'en-us', 'fr-ca'],
      required: true
    }
  ],
  minimalAge: 18,
  mobilePhone: {
    enableCountryCodeSelection: true
  },
  onSuccessNavigateTo: '/account',
  showBirthDateField: true,
  showSmsSectionLocales: ['en-ca', 'en-us', 'fr-ca']
} satisfies RecursivePartial<SignUpConfig>
